module.exports = __webpack_public_path__ + "static/media/29FUNOV9.241d378c.jpg";